<template>
    <div>
        <b-table
            id="unpaid-approved-purchase-totals"
            responsive
            stacked="md"
            hover
            small
            caption-top
            :fields="columns"
            :items="payablePurchasesSummary"
            show-empty
        >
            <template v-slot:cell(_actions)="row">
                <b-col class="actions-column">
                    <b-button variant="info"
                              size="sm"
                              @click="onPayClick(row)"
                    >
                        <fa-icon fixed-width :icon="['fal', 'money-check']" />
                        Pay
                    </b-button>
                </b-col>
            </template>
        </b-table>

        <b-modal id="payment-modal"
                 v-model="modalShowing"
                 size="xl"
                 centered
                 footer-class="d-none"
        >
            <template #modal-title>
                Record a Payment
            </template>

            <PaymentForm
                v-bind="payment"
                @update:payment="payment = {...$event}"
                @cancel-payment="onCancelPayment"
                @confirm-payment="onConfirmPayment"
            >
                <template v-slot:institution_options>
                    <b-select-option :value="payment.applicantId">
                        {{ ficeName(payment.applicantId) || '-- Select Institution --' }}
                    </b-select-option>
                </template>
            </PaymentForm>
            <template #modal-footer>
                <span />
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { Arc } from '$Shared/@arc/vue-arc';
import PaymentForm from './PaymentForm';

export default {
    name: 'PayablesSummary',

    components: {
        PaymentForm
    },

    data() {
        return {
            columns: [
                { key: 'academic_year', label: 'AY', sortable: true },
                {
                    key: 'applicant_id',
                    label: 'Institution',
                    formatter: (value) => this.ficeName(value),
                    sortable: true
                },
                {
                    key: 'purchases_total',
                    label: 'Payable',
                    headerTitle: 'The sum of approved, unpaid purchases for an application',
                    formatter: (value) => Arc.Money.asCurrency(value),
                    sortable: true
                },
                {
                    key: 'purchase_ids',
                    label: 'Purchases',
                    headerTitle: 'The number of approved, unpaid purchases for an application',
                    formatter: (value) => value.length || 0,
                    sortable: true
                },
                // {
                //     key: 'budgets_total',
                //     label: 'Budgeted',
                //     headerTitle: 'Total of budgeted activity costs',
                //     formatter: (value, key, item) => {
                //         return Arc.Money.asCurrency(value);
                //     },
                //     sortable: true
                // },
                // {
                //     key: 'percent_of_budget',
                //     label: '%Budgeted',
                //     formatter: (value, key, item) => {
                //         return Arc.Numbers
                //             .toFixedPercent(item.purchases_total, item.budgets_total);
                //     },
                //     sortable: true
                // },
                {
                    key: 'funding_limit',
                    label: 'Awarded Amount',
                    formatter: (value) => Arc.Money.asCurrency(value),
                    sortable: true
                },
                {
                    key: 'percent_of_awarded',
                    label: '%Awarded',
                    formatter: (value, key, item) => {
                        return Arc.Numbers.toFixedPercent(item.purchases_total, item.funding_limit);
                    },
                    sortable: true
                },
                { key: '_actions', label: 'Actions' },
            ],

            modalShowing: false
        };
    },

    computed: {
        ...mapState('payment', {
            payablePurchasesSummary: 'payablePurchasesSummary',
        }),

        ...mapGetters({
            ficeName: 'ref/ee/ficeName',
            paymentGetter: 'payment/payment',
            currentAy: 'ref/global/currentAy',
        }),

        payment: {
            get() { return this.paymentGetter; },
            set(keyValuePairs) { this.edit(keyValuePairs); }
        },
    },

    async created() {
        // FIXME: This ref could be wrong when we display rows for multiple AYs
        // TODO: We should either have a parent component/route to select AY
        //   or update ref stores to handle multiple AYs concurrently @see: ref/localApplication
        // FIXME: Hardcoded value for AY
        this.fetchRefEe(this.currentAy);
        await this.fetchPayablesSummary();
    },

    methods: {
        ...mapActions({
            fetchRefEe: 'ref/ee/fetchRefEe',
            fetchPayablesSummary: 'payment/fetchPayablesSummary',
            fetchApplicationCosts: 'cost/fetchApplicationCosts',
            edit: 'payment/edit',
            createPayment: 'payment/create',
            resetPayment: 'payment/resetPayment'
        }),

        async onPayClick(row) {
            await this.$store.dispatch('payment/edit', {
                key: 'amount',
                value: row.item.purchases_total
            });

            await this.$store.dispatch('payment/edit', {
                key: 'applicantId',
                value: row.item.applicant_id
            });

            await this.$store.dispatch('payment/edit', {
                key: 'applicationId',
                value: row.item.application_id
            });

            await this.$store.dispatch('payment/edit', {
                key: 'purchaseIds',
                value: row.item.purchase_ids
            });

            await this.$store.dispatch('payment/edit', {
                key: 'date',
                value: null
            });

            await this.$store.dispatch('payment/edit', {
                key: 'aasisNumber',
                value: null
            });

            this.modalShowing = true;
        },

        onCancelPayment($event) {
            // NOTE: This is commented out only as a UX choice
            // this.resetPayment()
            this.modalShowing = false;
        },

        async onConfirmPayment() {
            try {
                await this.createPayment(this.payment);
                console.log('payment', this.payment);
                this.modalShowing = false;
                this.resetPayment();
                this.fetchPayablesSummary();
            } catch (error) {
                this.modalShowing = true;
            }
        },

    },
};
</script>

<style lang="scss" scoped>
@import '$StyleVars';
</style>
